import type { LandingVariantKey } from '@sigma/patient-common/landing/landingVariantKeys.js';

/**
 * Content for a single landing-page variant.
 *
 * NOTE: this is intentionally minimal, mock content for the variant mechanism. The real per-campaign
 * landing pages will replace this — at which point a variant may instead point to its own component
 * (add an optional `component` field here) rather than overriding copy on the shared page.
 */
export interface LandingVariantContent {
    /** Hero headline shown in place of the default hero for this campaign. */
    heading: string;
    /** Supporting hero copy. */
    subtitle: string;
    /** Primary call-to-action label. */
    cta: string;
}

/**
 * Per-variant content registry, keyed by {@link LandingVariantKey}. The default landing (no key) uses the
 * standard sections and has no entry here.
 */
export const landingVariants: Record<LandingVariantKey, LandingVariantContent> = {
    glp1: {
        heading: 'GLP-1 weight loss, prescribed online',
        subtitle: 'Talk to a licensed doctor and get a personalised GLP-1 treatment plan — without a clinic visit.',
        cta: 'See if GLP-1 is right for you',
    },
};
